import React, { useState, useCallback, memo } from 'react';
import {Grid, TextField, Typography, Button, Box, Alert} from "@mui/material";
import { useDispatch } from "react-redux";
import { styled } from "@mui/material/styles";
import {Link as LinkUI, useNavigate} from "react-router-dom";
import {forgotPassword} from "../index";
import {Loader} from "../../../../Components";

const Link = styled(LinkUI)(({ theme }) => ({
    color: theme.palette.primary.main,
    textDecoration: 'none',
    fontSize: '1.2rem',
    '&:hover': {
        cursor: 'pointer',
        color: theme.palette.primary.dark,
    },
}));

export const ForgotPassword = memo(() => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [formState, setFormState] = useState({
        isLoading: false,
        message: "",
        status: "info",
        errors: {},
        email: ''
    });

    const handleSubmit = useCallback(async () => {
        if (!formState.email) {
            setFormState(prev => ({ ...prev, errors: { email: "Email is required." } }));
            return;
        }
        setFormState(prev => ({ ...prev, isLoading: true }));
        await forgotPassword({ dispatch, data: { email: formState.email } }).then((res) => {
            setFormState(prev => ({ ...prev, isLoading: false }));
            if (res.success && res.data?.user_id) {
                navigate('/auth/forgot-password/verify');
            }
            setFormState(prev => ({
                ...prev,
                errors: res.errors,
                message: res.message,
                status: res.status
            }));
        });
    }, [formState.email, dispatch, navigate]);

    const handleKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            handleSubmit();
        }
    }, [handleSubmit]);

    const handleChange = useCallback((e) => {
        setFormState(prev => ({
            ...prev,
            email: e.target.value,
            errors: { ...prev.errors, email: null }
        }));
    }, []);

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography align={"center"} mb={4} fontWeight={"bold"} className={"title"} variant={"h1"}>Forgot Password</Typography>
                <Typography align={"center"} mb={4} variant={"body1"}>Enter your registered email. We will send a one-time verification code; use it on the next screen to continue.</Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container spacing={2}>
                    {formState.message && (
                        <Grid item xs={12}>
                            <Alert severity={formState.status}>{formState.message}</Alert>
                        </Grid>
                    )}
                    <Grid item xs={12}>
                        <TextField
                            value={formState.email}
                            onChange={handleChange}
                            onKeyDown={handleKeyDown}
                            required
                            name="email"
                            label="Email"
                            type="email"
                            fullWidth
                            error={!!formState.errors?.email}
                            helperText={formState.errors?.email}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        {formState.isLoading ? (
                            <Loader isLoading={formState.isLoading} height={3} type={"linear"} />
                        ) : (
                            <Button
                                fullWidth={true}
                                variant="contained"
                                disableElevation={true}
                                onClick={handleSubmit}
                                size="large"
                                sx={{ height: 50, fontSize: 18, textTransform:"capitalize"}}
                            >
                                Request
                            </Button>
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <Box sx={{ mt: 2, textAlign: 'center' }}>
                            <Typography variant={"body2"}>Remembered your password? <Link to="/login">Login</Link></Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
});